import { render } from "./index.vue?vue&type=template&id=78f83ddc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=78f83ddc&lang=less&scoped=true"

import exportComponent from "/root/workspace/service-web_SY5C/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f83ddc"]])

export default __exports__